<div class="page-wrapper">
  <tax-dev-pages-menu class="menu"></tax-dev-pages-menu>

  <div class="page">
    <router-outlet></router-outlet>
  </div>
</div>
